import { ReduxUtils } from 'UI-Dash-Commons-UI';

import NotificationDisplayUtils from '../utils/NotificationDisplayUtils';
import { activateSection } from '../../MainNavigation/redux/actions';
import MainNavigationState from '../../MainNavigation/types/MainNavigationState';
import SectionUtils from '../../MainNavigation/utils/SectionUtils';

import * as constants from './constants';

export const focusSectionFrame = ReduxUtils.createAction( constants.ACTION_FOCUS_SECTION_FRAME, 'sectionSpec', 'iframeSectionSpec' );
export const updateContentHeight = ReduxUtils.createAction( constants.ACTION_UPDATE_CONTENT_HEIGHT, 'newHeight' );

export const showNotification = ( message: string, type: NotificationDisplayUtils ) => () =>
{
    NotificationDisplayUtils.showMessage( message, type );
};

export const updateActiveSection = ( newUrl: string, pushUrl = false, updateTimeStamp = false ) => ( dispatch, getState ) =>
{
    const mainNavigationState: MainNavigationState = getState().mainNavigation;

    if ( mainNavigationState.menuSpec &&
        mainNavigationState.menuSpec.leftSideMenu &&
        mainNavigationState.menuSpec.leftSideMenu.menu )
    {
        const newActiveSection = SectionUtils.getActiveMenuSectionFromUrl( mainNavigationState.menuSpec.leftSideMenu.menu, newUrl );

        if ( newActiveSection )
        {
            dispatch( activateSection( newActiveSection, pushUrl, updateTimeStamp ) );
        }
    }
};

